import {estimateStatuses} from "../EstimateState";

export const RequestsPurchaseTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue) => value === null ? "не занумерован".includes(filterValue.toLowerCase()) : value.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "order",
        "id": "orderNumber",
    },
    {
        "idFromColumnFilter": "namePlan",
        "id": "namePlan"
    },
    {
        "idFromColumnFilter": "date",
        "id": "date",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "estimateState",
        "id": "estimateState",
        "filterFn": (value, filterValue) => estimateStatuses[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]